
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("6YiQT"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("6YiQT", function(module, exports) {

let $5136f855ce828931$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5136f855ce828931$var$load("cRtGo"),
    $5136f855ce828931$var$load("3Zwna"),
    $5136f855ce828931$var$load("3q2Ng"),
    $5136f855ce828931$var$load("jRpDi"),
    $5136f855ce828931$var$load("55OBD"),
    $5136f855ce828931$var$load("dYtBN"),
    $5136f855ce828931$var$load("kNV5Y"),
    $5136f855ce828931$var$load("jUBhK"),
    $5136f855ce828931$var$load("ddJJa"),
    $5136f855ce828931$var$load("27glK"),
    $5136f855ce828931$var$load("bvY53"),
    $5136f855ce828931$var$load("hnbN4"),
    $5136f855ce828931$var$load("7jSfd"),
    $5136f855ce828931$var$load("4HZlX"),
    $5136f855ce828931$var$load("kDqHr"),
    $5136f855ce828931$var$load("gT8XU"),
    $5136f855ce828931$var$load("3GuOt"),
    $5136f855ce828931$var$load("3Mspc"),
    $5136f855ce828931$var$load("9aQIt"),
    $5136f855ce828931$var$load("XZauT"),
    $5136f855ce828931$var$load("4S1SF"),
    $5136f855ce828931$var$load("lm9Lt"),
    $5136f855ce828931$var$load("9wPDc"),
    $5136f855ce828931$var$load("1MWOL"),
    $5136f855ce828931$var$load("6fQco"),
    $5136f855ce828931$var$load("aOY32"),
    $5136f855ce828931$var$load("3MYQs"),
    $5136f855ce828931$var$load("6SWFK"),
    $5136f855ce828931$var$load("5zapo"),
    $5136f855ce828931$var$load("jiFtb"),
    $5136f855ce828931$var$load("6wr18"),
    $5136f855ce828931$var$load("9atVd"),
    $5136f855ce828931$var$load("dek7I"),
    $5136f855ce828931$var$load("6iz6l"),
    $5136f855ce828931$var$load("4SCW2"),
    $5136f855ce828931$var$load("fdKpi"),
    $5136f855ce828931$var$load("ffEVr"),
    $5136f855ce828931$var$load("hhss7"),
    $5136f855ce828931$var$load("5JkDi"),
    $5136f855ce828931$var$load("eTYdV"),
    $5136f855ce828931$var$load("Wowvf"),
    $5136f855ce828931$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("dePaO"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("dePaO", function(module, exports) {

let $9a344721e5571114$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9a344721e5571114$var$load("cRtGo"),
    $9a344721e5571114$var$load("3Zwna"),
    $9a344721e5571114$var$load("6wr18"),
    $9a344721e5571114$var$load("3j4Bc"),
    $9a344721e5571114$var$load("2tIxk"),
    $9a344721e5571114$var$load("dLq4a"),
    $9a344721e5571114$var$load("27glK"),
    $9a344721e5571114$var$load("bvY53"),
    $9a344721e5571114$var$load("ffEVr"),
    $9a344721e5571114$var$load("hjqVy"),
    $9a344721e5571114$var$load("lPWNR"),
    $9a344721e5571114$var$load("eTYdV"),
    $9a344721e5571114$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("kzjOw"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("kzjOw", function(module, exports) {

let $ef967221df19effd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef967221df19effd$var$load("141M2"),
    $ef967221df19effd$var$load("c0JsV"),
    $ef967221df19effd$var$load("h3ABO"),
    $ef967221df19effd$var$load("2oPKP"),
    $ef967221df19effd$var$load("gSg0R"),
    $ef967221df19effd$var$load("4y0IB"),
    $ef967221df19effd$var$load("iEUHW"),
    $ef967221df19effd$var$load("kbwlB"),
    $ef967221df19effd$var$load("2YffH"),
    $ef967221df19effd$var$load("9XOeB"),
    $ef967221df19effd$var$load("xu7ej"),
    $ef967221df19effd$var$load("iQ4FP"),
    $ef967221df19effd$var$load("89s90"),
    $ef967221df19effd$var$load("grTPo"),
    $ef967221df19effd$var$load("73TmC"),
    $ef967221df19effd$var$load("k3Yy8"),
    $ef967221df19effd$var$load("jEvZI"),
    $ef967221df19effd$var$load("im1VN"),
    $ef967221df19effd$var$load("eD3Si"),
    $ef967221df19effd$var$load("9anPW"),
    $ef967221df19effd$var$load("84qtb"),
    $ef967221df19effd$var$load("iJxH8"),
    $ef967221df19effd$var$load("aapZc"),
    $ef967221df19effd$var$load("gnDXu"),
    $ef967221df19effd$var$load("5XC9j"),
    $ef967221df19effd$var$load("iqTGf"),
    $ef967221df19effd$var$load("3q2Ng"),
    $ef967221df19effd$var$load("jRpDi"),
    $ef967221df19effd$var$load("jUBhK"),
    $ef967221df19effd$var$load("ddJJa"),
    $ef967221df19effd$var$load("hnbN4"),
    $ef967221df19effd$var$load("lTK3c"),
    $ef967221df19effd$var$load("1WXdc"),
    $ef967221df19effd$var$load("b2FtX"),
    $ef967221df19effd$var$load("lmLaO"),
    $ef967221df19effd$var$load("f6ERn"),
    $ef967221df19effd$var$load("6iz6l"),
    $ef967221df19effd$var$load("4SCW2"),
    $ef967221df19effd$var$load("breTf"),
    $ef967221df19effd$var$load("lYmf7"),
    $ef967221df19effd$var$load("5HAR6"),
    $ef967221df19effd$var$load("arLFU"),
    $ef967221df19effd$var$load("cRtGo"),
    $ef967221df19effd$var$load("6wr18"),
    $ef967221df19effd$var$load("jvHRs"),
    $ef967221df19effd$var$load("2tIxk"),
    $ef967221df19effd$var$load("dLq4a"),
    $ef967221df19effd$var$load("27glK"),
    $ef967221df19effd$var$load("bvY53"),
    $ef967221df19effd$var$load("5NQgH"),
    $ef967221df19effd$var$load("hhss7"),
    $ef967221df19effd$var$load("Wowvf"),
    $ef967221df19effd$var$load("ffEVr"),
    $ef967221df19effd$var$load("hjqVy"),
    $ef967221df19effd$var$load("lPWNR"),
    $ef967221df19effd$var$load("jnVKv"),
    $ef967221df19effd$var$load("3Zwna"),
    $ef967221df19effd$var$load("7EorR"),
    $ef967221df19effd$var$load("bgHzk"),
    $ef967221df19effd$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.07fa5b57.js.map
